import { get, patch, prefix } from '../index';
import { getDomainBaseUrl } from '@ugc-utils/domains';
import { imagePaginationLimit } from '@ugc-components/ugc-pdp-review/utils';

const getReviewList = (params = {}): any => get(`${getDomainBaseUrl('catalog')}${prefix}/api/review/v1/search`, params);

const getReviewSummary = (productId, language): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/review/summary/v2`, { languageCode: language });

const getCustomerReview = productId =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/customer/review`, { pid: productId }, {}, false);

const getReviewImages = (productId, pageNumber = 1): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/review/images`, {
    limit: imagePaginationLimit,
    pageNumber,
  });

const getReview = (reviewId = '', languageCode = ''): any => {
  const params = ({ withoutDefaultTitle: true } as unknown) as any;
  if (languageCode) {
    params.languageCode = languageCode;
  }
  return get(`${getDomainBaseUrl('catalog')}${prefix}/api/review/${reviewId}`, params);
};

const postHelpful = (id, isHelpful) =>
  patch(`${getDomainBaseUrl('catalog')}${prefix}/api/review/${id}/helpful`, {
    response: isHelpful,
  });

const getProductReviewSummarySentence = ({
  productId,
  languageCode,
}: {
  productId: number;
  languageCode: string;
}): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/product/${productId}/review/summarization`, {
    languageCode,
  });

const getTagsV2 = (productId = '', params = {}): any =>
  get(`${getDomainBaseUrl('catalog')}${prefix}/api/tag/ai/${productId}`, params);

export {
  getReviewList,
  getReviewSummary,
  getCustomerReview,
  getReviewImages,
  getReview,
  postHelpful,
  getProductReviewSummarySentence,
  getTagsV2,
};
